import { JBaseApi } from '../base';
import {
    ApiWrapper,
    DavAddressBookContact,
    DavCalendarEvent,
    ImapInboxMail,
    OfficeProvider,
    OfficeProviderBaseUrls,
    OfficeSetConfigurationPayload,
    OfficeUserConfiguration,
} from '../../types';
import { OF } from '../../util';
export class JOfficeApi extends JBaseApi {
    public async isConfigurationValid(params?: { signal?: AbortSignal }): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'office',
                f: 'isConfigurationValid',
            } as OF,
            params?.signal,
        );
    }

    public async getConfiguration(params?: { signal?: AbortSignal }): Promise<ApiWrapper<OfficeUserConfiguration>> {
        return this.network.post(
            {
                o: 'office',
                f: 'getConfiguration',
            } as OF,
            params?.signal,
        );
    }

    public setConfiguration(
        payload: OfficeSetConfigurationPayload,
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF(
            {
                o: 'office',
                f: 'setConfiguration',
                userConfiguration: payload,
            } as OF,
            params?.signal,
        );
    }

    public async imapInboxCheckConnection(
        payload: {
            hostname: string;
            port: number;
            flags: string;
            username: string;
            password: string;
        },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'office',
                f: 'imapInboxCheckConnection',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async imapInboxGetEmails(
        payload: { limit?: number },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<ImapInboxMail[]>> {
        return this.network.post(
            {
                o: 'office',
                f: 'imapInboxGetEmails',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async imapInboxGetUnreadEmailsCount(params?: { signal?: AbortSignal }): Promise<ApiWrapper<number>> {
        return this.network.post(
            {
                o: 'office',
                f: 'imapInboxGetUnreadEmailsCount',
            } as OF,
            params?.signal,
        );
    }

    public async davCalendarCheckConnection(
        payload: {
            url: string;
            username: string;
            password: string;
        },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'office',
                f: 'davCalendarCheckConnection',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async davCalendarGetEvents(
        payload: {
            dateStart?: string;
            dateEnd?: string;
            limit?: number;
        },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<DavCalendarEvent[]>> {
        return this.network.post(
            {
                o: 'office',
                f: 'davCalendarGetEvents',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async davAddressBookCheckConnection(
        payload: {
            url: string;
            username: string;
            password: string;
        },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'office',
                f: 'davAddressBookCheckConnection',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async davAddressBookGetContacts(
        payload: { limit?: number },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<DavAddressBookContact[]>> {
        return this.network.post(
            {
                o: 'office',
                f: 'davAddressBookGetContacts',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public async getProviders(params?: { signal?: AbortSignal }): Promise<ApiWrapper<OfficeProvider[]>> {
        return this.network.post(
            {
                o: 'office',
                f: 'getProviders',
            } as OF,
            params?.signal,
        );
    }

    public async getProviderBaseUrls(params?: { signal?: AbortSignal }): Promise<ApiWrapper<OfficeProviderBaseUrls>> {
        return this.network.post(
            {
                o: 'office',
                f: 'getProviderBaseUrls',
            } as OF,
            params?.signal,
        );
    }
}
